import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import styles from "./../icon.css";
var IconChevron = function (_a) {
    var customStyle = _a.customStyle;
    return (_jsx("svg", { className: classNames(customStyle, styles.fill), width: "22", height: "9", viewBox: "0 0 22 9", children: _jsx("polygon", { fillRule: "evenodd", points: "6.5 4.5 14.06 -6.5 15.5 -4.405 9.38 4.5 15.5 13.405 14.06 15.5" }) }));
};
export default IconChevron;
